import Vue from 'vue'
import { WEBSOCKER_METHODS, ACCESS_TOKEN } from '@/store/mutation-types'
import CompanyApi from '@/api/company'

const socket = {
    state: {
        socket: {
            isConnected: false,
            message: '',
            reconnectError: false,
        },
        errorMsg: ''
    },

    mutations: {
        [WEBSOCKER_METHODS.SOCKET_ONOPEN](state, event) {
            state.socket.isConnected = true
            Vue.prototype.$socket = event.currentTarget
            Vue.prototype.$socket.sendObj(dataAssembly({
                operator: 'bind',
                operator_type: 'create',
                operator_params: {}
            }))
            setInterval(() => {
                Vue.prototype.$socket.sendObj(dataAssembly({
                    operator: 'ping',
                    operator_type: '',
                    operator_params: {}
                }))
            }, 10000)
        },
        [WEBSOCKER_METHODS.SOCKET_ONCLOSE](state, event) {
            state.socket.isConnected = false
        },
        [WEBSOCKER_METHODS.SOCKET_ONERROR](state, event) {
        },
        // default handler called for all methods
        [WEBSOCKER_METHODS.SOCKET_ONMESSAGE](state, message) {
            state.socket.message = message
        },
        // mutations for reconnect methods
        [WEBSOCKER_METHODS.SOCKET_RECONNECT](state, count) {
            Vue.prototype.$socket.sendObj(dataAssembly({
                operator: 'bind',
                operator_type: 'create',
                operator_params: {}
            }))
        },
        [WEBSOCKER_METHODS.SOCKET_RECONNECT_ERROR](state) {
            state.socket.reconnectError = true
        },
        WEBSOCKER_MUTATIONS_ERROR(state, { msg }) {
            state.errorMsg = msg
        }
    },

    actions: {
        // 给机器人发送消息
        WEBSOCKER_ACTIONS_SENDROBOTMSG({ commit, state, rootState }, { robotid, type, data }) {
            // console.log('给机器人的actions参数',robotid);
            // console.log('给机器人的actions参数',type);
            // console.log('给机器人的actions参数', data) // data是个对象，包含
            return new Promise((resolve, reject) => {
                try {
                    const main_id = rootState.user.info.id
                    const from = `NCNK_${main_id}`
                    const to = `${main_id}_${robotid}`
                    const contents = {
                        type: type,
                        data: data
                    }
                    // console.log('contents=', contents)
                    Vue.prototype.$socket.sendObj(dataAssembly({
                        operator: 'chat',
                        operator_type: 'text',
                        operator_params: {
                            from: from,
                            to: to,
                            contents: contents
                        }
                    }))
                    resolve()
                } catch (error) {
                    reject(error)
                }
            })

        },
        //再次发送
        //#region 
        // WEBSOCKER_ACTIONS_SENDROBOTMSGS({ commit, state, rootState }, { robotid, type, data }) {
        //     return new Promise((resolve, reject) => {
        //         try {
        //             const main_id = rootState.user.info.id
        //             const from = `NCNK_${main_id}`
        //             const to = `${main_id}_${robotid}`
        //             const contents = {
        //                 type: type,
        //                 data: data
        //             }
        //             Vue.prototype.$socket.sendObj(dataAssembly({
        //                 operator: 'friend_circle',
        //                 operator_type: 'create',
        //                 operator_params: {           
        //                     from: from,
        //                     to: to,
        //                     contents: contents
        //                 }
        //             }))
        //             resolve()
        //         } catch (error) {
        //             reject(error)
        //         }
        //     })
        // },
        //#endregion
        // 拦截机器人聊天消息
        WEBSOCKER_ACTIONS_ONCHATMSG({ commit, dispatch }, message) {
            const contents = message.contents
            // console.log(message,'机器人信息')

            const sub_id = message.sub_id
            // 下载订单进度
            if (contents.type == 'schedule') {
                dispatch('updateOrderDownloadStatus', { sub_id: sub_id, data: contents.data })
            }
            // 刷新会员列表进度
            if (contents.type == 'fans_refresh') {
                dispatch('updateFansRefreshStatus', { sub_id: sub_id, data: contents.data })
            }
            // 机器人日志
            if (contents.type == 'running_log') {
                dispatch('receiveWorkStatusLog', { sub_id: sub_id, data: contents.data })
            }
            // 机器人检测
            if (contents.type == 'testing') {
                dispatch('receiveWorkTestingMsg', { sub_id: sub_id, data: contents.data })
            }
            // 机器人消息
            if (contents.type == 'wechat_msg') {
                dispatch('receiveWorkWechatMsg', { sub_id: sub_id, data: contents.data })
            }
            // 僵尸粉进度
            if (contents.type == 'die_fans') {
                dispatch('updateDieFansStatus', { sub_id: sub_id, data: contents.data })
            }
        },
        // 拦截服务器端消息
        WEBSOCKER_ACTIONS_ONSERVERMSG({ commit, dispatch }, message) {
            const contents = message.contents
            // console.log(message,'来自服务器的消息')
            // 批量推送联盟更新消息
            if (contents.type == 'union') {
                if (contents.auth_type == 'taobao') {
                    const auth_id = contents.auth_id
                    const robotids = contents.sub_auth_info.map((item) => {
                        return `${item.sub_id}_${item.tag}`
                    })
                    console.log(robotids)
                    dispatch('BatchpushTask', {
                        robotids: robotids,
                        descs: '联盟更新',
                        apiFun: (str) => {
                            const sub_id = str.split("_")[0]
                            const tag = str.split("_")[1]
                            const paramsObj = {
                                auth_id: auth_id,
                                sub_id: sub_id,
                                tag: tag
                            }
                            return CompanyApi.setUpdateAuthTaobao(paramsObj)
                        }
                    })
                }
                if (contents.auth_type == 'jingdong') {
                    const auth_id = contents.auth_id
                    const robotids = contents.sub_auth_info.map((item) => {
                        return item.sub_id
                    })
                    const paramsObj = {}
                    contents.sub_auth_info.forEach((val) => {
                        paramsObj[val.sub_id] = {
                            auth_id: auth_id
                        }
                    })
                    dispatch('BatchpushTask', {
                        robotids: robotids,
                        descs: '联盟更新',
                        apiFun: (sub_id) => {
                            return CompanyApi.setUpdateAuthJingdong(Object.assign({ sub_id: sub_id }, paramsObj[sub_id]))
                        }
                    })
                }
                if (contents.auth_type == 'dy') {
                    const auth_id = contents.auth_id.map((item) => {
                        return item.auth_id
                    })
                    //const auth_id = contents.auth_id
                    const robotids = contents.sub_auth_info.map((item) => {
                        return item.sub_id
                    })
                    const paramsObj = {}
                    contents.sub_auth_info.forEach((val) => {
                        paramsObj[val.sub_id] = {
                            auth_id: auth_id
                        }
                    })
                    dispatch('BatchpushTask', {
                        robotids: robotids,
                        descs: '联盟更新',
                        apiFun: (sub_id) => {
                            // 存在疑惑暂不提交
                            //return CompanyApi.setUpdataAuthDouyin(Object.assign({ sub_id: sub_id }, paramsObj[sub_id]))
                            return CompanyApi.setUpdataAuthDouyin(Object.assign({ sub_id: sub_id, auth_id: auth_id[0] },))
                            //return CompanyApi.setUpdataAuthDouyin(Object.assign({ sub_id: sub_id }, {auth_id:paramsObj[sub_id][auth_id][0][auth_id]}))
                        }
                    })
                }
                if (contents.auth_type == 'pinduoduo') {
                    const auth_id = contents.auth_id
                    const robotids = contents.sub_auth_info.map((item) => {
                        return item.sub_id
                    })
                    const paramsObj = {}
                    contents.sub_auth_info.forEach((val) => {
                        paramsObj[val.sub_id] = {
                            auth_id: auth_id
                        }
                    })
                    dispatch('BatchpushTask', {
                        robotids: robotids,
                        descs: '联盟更新',
                        apiFun: (sub_id) => {
                            return CompanyApi.setUpdateAuthPinduoduo(Object.assign({ sub_id: sub_id }, paramsObj[sub_id]))
                        }
                    })
                }
            }
        }
    }
}

export default socket

// 组装通讯数据
function dataAssembly({ operator, operator_type, operator_params }) {
    const data = {
        "code": 0,
        "msg": "success",
        "data": {
            "operator": operator,
            "operator_type": operator_type,
            "operator_params": operator_params,
            "token": Vue.ls.get(ACCESS_TOKEN),
            "client": "web"
        }
    }
    return data
}